export const PLUGIN_ID = 'country-select';
